import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import Paragraph from "../../../elements/p/Paragraph";
import searchContext from "../../../../dataManager/context/searchContext";
import categoriesContext from "../../../../dataManager/context/categoriesContext";

const FilterProducts = () => {
  //context variables
  const { categories } = useContext(categoriesContext);

  return (
    <section className="mt-24 bg-smoot py-14 md:mt-28">
      <div className="flex flex-wrap justify-center gap-y-2 space-x-2 md:space-x-4 lg:space-x-5">
        {categories.map((category) => (
          <FilterBox category={category} />
        ))}
      </div>
    </section>
  );
};

const FilterBox = ({ category }) => {
  //context variables
  const { addFilters } = useContext(searchContext);

  //navigate
  const navigate = useNavigate();

  const handleClick = (filters) => {
    //add filters
    addFilters(filters);

    //navigate to all products
    navigate("/produits");
  };

  return (
    <div className="flex cursor-pointer justify-center  ">
      <Paragraph
        onClick={() => handleClick(category.getName)}
        classe="px-5 py-1.5 rounded-full border border-secondary-light text-secondary-light animate hover:border-primary hover:text-primary"
      >
        {category.getName}
      </Paragraph>
    </div>
  );
};

export default FilterProducts;
